import { combineEpics, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import {
  custom,
  trackPageView,
  trackClick,
} from 'common/utils/instrumentation';
import { getCompanyID } from 'helper/user';
import { userInfoSelector } from 'selectors/app-selector';
import TrackGADuck from 'ducks/track-ga-duck.js';

const trackGAExpressHomepageWebClickEpic = (action$, state$) =>
  action$.pipe(
    ofType(TrackGADuck.types.EXPRESS_HOMEPAGE_WEB_CLICK),
    mergeMap(action => {
      const { event, category, name, extra } = action;

      const userInfo = userInfoSelector(state$.value);
      const companyID = getCompanyID(userInfo);

      trackClick(event, category, name, {
        [custom.COMPANY_ID]: companyID,
        ...extra,
      });

      return EMPTY;
    }),
  );

const trackGAExpressBookingsWebClickEpic = (action$, state$) =>
  action$.pipe(
    ofType(TrackGADuck.types.EXPRESS_BOOKINGS_WEB_CLICK),
    mergeMap(action => {
      const { event, category, name, extra } = action;

      const userInfo = userInfoSelector(state$.value);
      const companyID = getCompanyID(userInfo);

      trackClick(event, category, name, {
        [custom.COMPANY_ID]: companyID,
        ...extra,
      });

      return EMPTY;
    }),
  );

const trackGAExpressBookingsWebPageViewEpic = (action$, state$) =>
  action$.pipe(
    ofType(TrackGADuck.types.EXPRESS_BOOKINGS_WEB_PAGE_VIEW),
    mergeMap(action => {
      const { event, category, extra } = action;

      const userInfo = userInfoSelector(state$.value);
      const companyID = getCompanyID(userInfo);

      trackPageView(event, category, {
        [custom.COMPANY_ID]: companyID,
        ...extra,
      });

      return EMPTY;
    }),
  );

export default combineEpics(
  trackGAExpressHomepageWebClickEpic,
  trackGAExpressBookingsWebClickEpic,
  trackGAExpressBookingsWebPageViewEpic,
);
